import { Navigate } from "react-router";

import { ROUTES } from "@/constants/routes";
import { useAuth } from "@/providers/auth-provider";

/**
 * Sign-in screen.
 *
 * `login()` passes no organization: the Shadow Realm has its own Kinde
 * environment with a single organization, so authenticating there resolves to
 * it. There is deliberately no "create account" action — an account in this
 * environment is the access gate and must be granted, never self-served.
 */
export const Login = () => {
	const { authError, isAuthenticated, isLoadingAuth, login } = useAuth();

	if (isAuthenticated) {
		return <Navigate replace to={ROUTES.ORGANIZATION_MAP} />;
	}

	return (
		<div className="flex h-dvh flex-col items-center justify-center gap-4 p-6 text-center">
			<h1 className="text-primary text-xl font-semibold">Shadow Realm</h1>
			<p className="text-secondary text-sm">Internal configuration tool.</p>

			<button
				className="bg-brand-solid rounded-lg px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
				disabled={isLoadingAuth}
				onClick={() => void login()}
				type="button"
			>
				{isLoadingAuth ? "Loading…" : "Sign in"}
			</button>

			{authError && <p className="text-error-primary text-sm">{authError}</p>}
		</div>
	);
};
